module.exports = __webpack_public_path__ + "img/12.92a080b8.jpg";